@if(isShowToast){
<div class="fixed top-3 right-3 z-50 flex flex-col gap-2 w-80 max-w-full">
    @if(toastType == 'danger'){
    <div
        class="rounded-md border border-[#f5c2c7] bg-[#f8d7da] p-2 flex gap-2 items-center font-sans font-normal text-sm leading-5 text-[#842029]">
        <div class="size-5 *:size-full flex items-center shrink-0" [innerHTML]="icons.crossIcon"></div>
        <div class="font-sans font-normal text-sm leading-5">{{toastMessage}}</div>
    </div>
    }
    @if(toastType == 'success'){
    <div
        class="rounded-md border border-[#badbcc] bg-[#d1e7dd] p-2 flex gap-2 items-center font-sans font-normal text-sm leading-5 text-[#0f5132]">
        <div class="size-5 *:size-full flex items-center shrink-0" [innerHTML]="icons.check"></div>
        <div class="font-sans font-normal text-sm leading-5">{{toastMessage}}</div>
    </div>
    }
    @if(toastType == 'warning'){
    <div
        class="rounded-md border border-[#ffecb5] bg-[#fff3cd] p-2 flex gap-2 items-center font-sans font-normal text-sm leading-5 text-[#664d03]">
        <div class="size-5 *:size-full flex items-center shrink-0" [innerHTML]="icons.alertTriangle"></div>
        <div class="font-sans font-normal text-sm leading-5"> {{toastMessage}}</div>
    </div>
    }
</div>
}